//#region src/item_hidden_state.ts
let ItemHiddenState = /* @__PURE__ */ function(ItemHiddenState) {
	ItemHiddenState[ItemHiddenState["Shown"] = 0] = "Shown";
	ItemHiddenState[ItemHiddenState["HiddenIndefinitely"] = 1] = "HiddenIndefinitely";
	ItemHiddenState[ItemHiddenState["HiddenUntilTomorrow"] = 2] = "HiddenUntilTomorrow";
	return ItemHiddenState;
}({});
//#endregion
export { ItemHiddenState };

//# sourceMappingURL=item_hidden_state.js.map